import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/useTheme';
import { Moon, Sun } from 'lucide-react';
import { BchLogo } from './BchLogo';

export function Header() {
  const { theme, setTheme } = useTheme();

  return (
    <header className="sticky top-0 z-30 border-b bg-background/80 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between gap-3 px-4">
        <div className="flex items-center gap-2.5">
          <BchLogo className="h-8 w-8" />
          <div className="leading-tight">
            <div className="text-base font-bold tracking-tight">BCH Signature</div>
            <div className="hidden text-[11px] text-muted-foreground sm:block">
              Professional email signatures
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden rounded-full border bg-primary/10 px-3 py-1 text-xs font-medium text-primary sm:inline-block">
            Free · No sign-up
          </span>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </Button>
        </div>
      </div>
    </header>
  );
}
